import type { LifecycleRow } from '../../enterprisega/framework';

type Props = { funnel?: LifecycleRow[] };

export function CustomerLifecyclePanel({ funnel = [] }: Props) {
  const maxCount = Math.max(...funnel.map((f) => f.count), 1);

  return (
    <div className="space-y-2">
      {funnel.map((stage) => (
        <div key={stage.stage} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{stage.stage}</p>
            <span className="text-xs text-slate-500">{stage.rate}</span>
          </div>
          <div className="mt-2 flex items-center gap-3">
            <div className="h-2 flex-1 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
              <div
                className="h-full rounded-full bg-brand-500"
                style={{ width: `${(stage.count / maxCount) * 100}%` }}
              />
            </div>
            <span className="text-xs font-medium text-slate-600 dark:text-slate-400">{stage.count}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
